import React from "react";
import { AiOutlineLock } from "react-icons/ai";

const NoDataFound = () => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center mt-5"> 
      <AiOutlineLock color="#a6a8a9" className="text-4xl md:text-8xl " />
      <span className="text-lg md:text-xl  text-[#a6a8a9] font-bold">
        No Data Found
      </span> 
    </div>
  );
};

export default NoDataFound;
